/*
URL FRONT-END
*/
export const url_panel = "/panel";
export const url_invoices = "/invoices";

/*
URL BACK-END
*/
export const api_modal = `/modal`;
export const api_country = `/country`;
export const api_marketNews = `/marketNews`;
export const api_customer_notifications_shipment_step = `/CustomerNotificationShipmentStep`;
export const api_notification_shipment_step_rule = `/NotificationShipmentStepRule`;
export const api_agents = `/agent`;
export const api_pending_category = `/PendingCategory`;
export const api_subpending_category = `/SubpendingCategory`;
export const api_subpending_category_by_category_id = `/SubpendingCategory/Category`;
export const api_users = `/user`;
export const api_users_dropdown = `/user/dropdown`;
export const api_users_from_customer = `/user/from-customer`;
export const api_customer_user = `/customeruser`;
export const api_integrators = `/integrator`;
export const api_partners = `/partner`;
export const api_reports = `/report`;
export const api_operation = `/operation`;
export const api_free_time = `/freeTime`;
export const api_batch = `/batch`;
export const api_ai_oraculo_talk = `/aioraculo`;
export const api_free_time_delete = `/freeTime/delete`;
export const api_freightType = `/freightType`;
export const api_currency = `/currency`;
export const api_currency_quote = `/currencyquote`;
export const api_suppliers = `/customerSupplier`;
export const api_paymentStatus = `/paymentStatus`;
export const api_tax = `/tax`;
export const api_expense = `/expense`;
export const api_serviceType = `/serviceType`;
export const api_loadType = `/loadType`;
export const api_incoterm = `/incoterm`;
export const api_customer = `/customer`;
export const api_locationType = `/locationType`;
export const api_containerType = `/containerType`;
export const api_documentType = `/documentType`;
export const api_platform_dashboard_use = `/dashboard/platform-dashboard-use`;
export const api_shipment_month_by_modal = `/dashboard/shipment-month-by-modal`;
export const api_shipment_month_by_eta = `/dashboard/shipment-by-eta`;
export const api_shipment_month_by_route = `/dashboard/shipments-by-route`;
export const api_shipment_month_by_route_2 = `/dashboard/shipments-by-route-2`;
export const api_shipment_by_created_at = `/dashboard/shipment-by-created-at`;
export const api_expected_arrival_risk = `/dashboard/expected-arrival-risk`;
export const api_shipments_gross_weight_sum = `/dashboard/shipments-gross-weight-sum`;
export const api_shipments_freight_amount_sum = `/dashboard/shipments-freight-amount-sum`;
export const api_dashboard_route_review = `/dashboard/route-review`;
export const api_shipments_in_transportation = `/dashboard/shipments-in-transportation`;
export const api_shipment_load_amount = `/dashboard/shipment-load-amount`;
export const api_dashboard_operational_cost = `/dashboard/operational-cost`;
export const api_packageType = `/PackageType`;
export const api_aditionalService = `/AditionalService`;
export const api_location = `/location`;
export const api_authenticate = `/authenticate`;
export const api_authenticate_partner = `/authenticate/auth-partner`;
export const api_authenticate_reset_internal = `/authenticate/reset-password-internal`;
export const api_notification = `/notification`;
export const api_notification_readAll = `/notification/readAll`;
export const api_notification_read = `/notification/read`;
export const api_general_search = `/generalsearch/search`;
export const api_trix_activity_rule = `/TrixActivityRule`;
export const api_trix_order_item_rule = `/TrixOrderItemRule`;
export const api_notification_count = `/notification/count`;
export const api_quotation_status = `/quotationStatus`;
export const api_external_data = `/externalData`;
export const api_shipment_status = `/shipmentStatus`;
export const api_shipment_responsibles = `/shipment/user-responsibles`;
export const api_carrier = `/carrier`;
export const api_pending_report = `/ShipmentPending/report`;
export const api_check_shipping_agent = `/shipment/check-shipping-agent`;
export const api_customerUser_get_from_customer = `/customerUser/get-all-from-customer`;
export const api_customerUser_get_user_documents = `/customerUser/get-user-documents`;
export const api_pending_shipment_activity = `/PendingShipmentActivity`;

export const api_check_quotation_agent = `/quotation/check-quotation-agent`;
export const api_internalid_exists = `/shipment/internalid-exists`;
export const api_quotations = `/quotation`;
export const api_quotations_list = `/quotation/list`;
export const api_quotation_history = `/QuotationHistory`;
export const api_quotation_attachment = `/QuotationAttachment`;
export const api_shipment_attachment = `/ShipmentAttachment`;
export const api_shipment_pre_alert = `/ShipmentPreAlert`;
export const api_shipment_pre_alert_attachment = `/ShipmentPreAlertAttachment`;
export const api_quotation_result = `/QuotationResult`;
export const api_quotation_send_message = `/QuotationHistory/sendMessage`;
export const api_quotation_create = `/quotation/request-quotation`;
export const api_quotation_approve = `/quotation/approve`;
export const api_quotation_reject = `/quotation/reject`;
export const api_quotation_attachment_remove = `/QuotationAttachment/remove`;
export const api_quotation_result_attachment_remove = `/QuotationResultAttachment/remove`;
export const api_quotation_result_attachment_download = `/QuotationResultAttachment/download`;
export const api_quotation_attachment_download = `/QuotationAttachment/download`;
export const api_shipment_attachment_download = `/ShipmentAttachment/download`;
export const api_shipment_attachment_update_approval_status = `/ShipmentAttachment/update-approval-status`;
export const api_shipment_attachment_download_all = `/ShipmentAttachment/download-all`;
export const api_shipment_volume_invoice_items = `/ShipmentVolumeInvoiceItem`;
export const api_shipment_attachment_remove = `/ShipmentAttachment/remove`;
export const api_shipment_volume_add = `/ShipmentVolume/add`;
export const api_shipment_volume_invoice_add = `/ShipmentVolumeInvoice/add`;
export const api_shipment_tax_add = `/ShipmentTax/add`;
export const api_shipment_expense_add = `/ShipmentExpense/add`;
export const api_shipment_cash_add = `/ShipmentCash/add`;
export const api_shipment_volume_remove = `/ShipmentVolume/remove`;
export const api_shipment_tax_remove = `/ShipmentTax/remove`;
export const api_shipment_expense_remove = `/ShipmentExpense/remove`;
export const api_shipment_expense_paid = `/ShipmentExpense/paid`;
export const api_shipment_tax_paid = `/ShipmentTax/paid`;
export const api_shipment_cash_remove = `/ShipmentCash/remove`;
export const api_shipment_cash_update = `/ShipmentCash`;
export const api_shipment_volume_invoice_remove = `/ShipmentVolumeInvoice/remove`;
export const api_shipment_invoice_item_remove = `/ShipmentVolumeInvoiceItem/remove`;
export const api_shipment_pending_remove = `/ShipmentPending`;
export const api_shipment_remove = `/Shipment/delete`;
export const api_quotation_attachment_add = `/QuotationAttachment/add`;
export const api_ai_tom = '/AiTom'
export const api_ai_tom_process = `/AiTom/process`;
export const api_ai_tom_create_shipment = `/AiTom/create-shipments`;
export const api_ai_tom_create_quotation = `/AiTom/create-quotation`;
export const api_digital_certificate = `/DigitalCertificate`;
export const api_quotation_result_upsert = `/QuotationResult/upsert`;
export const api_shipment_attachment_add = `/ShipmentAttachment/add`;
export const api_shipment_attachment_tom_add_multiples = `/ShipmentAttachment/tom/add-multiples`;
export const api_shipment_attachment_add_from_azure = `/ShipmentAttachment/add-from-azure`;
export const api_shipment_import_finance_xml = `/Shipment/import-finance-xml`;
export const api_shipment_volume_invoice_item_add = `/ShipmentVolumeInvoiceItem/add`;
export const api_shipment_update = `/Shipment/update`;
export const api_shipment_update_shipment_step = `/Shipment/updateShipmentStep`;
export const api_shipment_create = `/Shipment/create`;
export const api_shipment_create_multiples = `/Shipment/create-multiples`;
export const api_add_orderItems_to_shipment = `/Shipment/add-items-to-shipment`;
export const api_shipment_adjustment_orderitems = `/Shipment/adjustment-orderitems`;
export const api_shipment_update_step = `/ShipmentStep/update`;
export const api_shipment_update_actual_step = `/Shipment/step`;
export const api_shipment_update_limit_time_arrive = `/Shipment/update-limit-time-arrive`;
export const api_shipment_update_partial = `/Shipment/update-partial`;
export const api_shipment_update_partial_v2 = `/Shipment/update-partial-v2`;
export const api_shipment_import_di_xml = `/Shipment/import-di-xml`;
export const api_shipment_milestone_next_step = `/ShipmentMilestone/step`;
export const api_shipment_milestone_return_step = `/ShipmentMilestone/return-step`;
export const api_shipment_milestone_step_order = `/ShipmentMilestone/step-order`;
export const api_shipment_milestone_step_status = `/ShipmentMilestone/step-status`;
export const api_operationalSla = `/OperationalSLA`;
export const api_operationalSla_create = `/operationalSLA/create`;
export const api_import_operationalSLA = `/operationalSLA/import`;
export const api_shipments = `/shipment`;
export const api_shipments_shipment_journey = `/shipment/shipment-journey`;
export const api_import_shipment = `/shipment/import`;
export const api_update_shipment_import = `/shipment/update-shipment-import`;
export const api_update_activity_status = `/shipment/update-activity-status`;
export const api_agent_import = `/agent/import`;
export const api_agent_deactive = `/agent/deactive`;
export const api_partner_import = `/partner/import`;
export const api_supplier_import = `/customersupplier/import`;
export const api_template_import_operationalSLA = `/operationalSLA/down-template-import-operationalSLA`;
export const api_template_import_shipment = `/shipment/down-template-import-shipment`;
export const api_template_update_shipment = `/shipment/down-template-update-shipment`;
export const api_template_import_agent = `/agent/down-template-import-agent`;
export const api_template_import_partner = `/partner/down-template-import-partner`;
export const api_template_import_supplier = `/customersupplier/down-template-import-supplier`;
export const api_template_import_order_item = `/orderitem/down-template-import-order-item`;
export const api_match_location = `/shipment/match-location`;
export const api_match_carrier = `/carrier/match-carrier`;
export const api_shipment_pendings = `/shipment/shipmentPendings`;
export const api_shipment_withpendings = `/shipment/pendings`;
export const api_shipment_process = `/shipment/process`;
export const api_shipment_finance = `/shipment/finance`;
export const api_shipment_milestone = `/ShipmentMilestone`;
export const api_shipment_pending = `/ShipmentPending`;
export const api_shipment_pending_update_status = `/ShipmentPending/update-status`;
export const api_shipment_my_pending = `/ShipmentPending/my`;
export const api_shipment_user_pending = `/ShipmentPending/user`;
export const api_shipment_pending_users = `/ShipmentPending/users`;
export const api_shipment_taxes = `/shipmentTax`;
export const api_shipment_cash = `/shipmentCash`;
export const api_shipment_cash_item = `/ShipmentCashItem`;
export const api_shipment_cash_by_customer = `/shipmentCash/customer`;
export const api_shipment_cash_totals = `/shipmentCash/totals`;
export const api_shipment_expenses = `/shipmentExpense`;
export const api_shipment_list = `/shipment/list`;
export const api_shipment_statistic_modals = `/shipment/get-shipment-statistics-modals`;
export const api_shipment_statistic_origins = `/shipment/get-shipment-statistics-origins`;
export const api_shipment_statistic_pendings = `/shipment/get-shipment-statistics-pendings`;
export const api_shipment_statistic_warnings = `/shipment/get-shipment-statistics-warnings`;
export const api_shipment_list_arrive = `/shipment/list-arrive`;
export const find_vsantos_tracking = `/shipment/find-vsantos-tracking`;
export const api_shipment_tracking = `/shipment/tracking`;
export const api_shipment_tracking_list = `/shipment/tracking-list`;
export const api_shipment_tracking2 = `/shipment/tracking2`;
export const api_shipment_orderitems = `/shipment/orderitems`;
export const api_customer_dashboard_target = '/customerDashboardTarget'
export const api_dashboard = `/dashboard`;
export const api_dashboard_shipment_statistics = `/dashboard/shipment-statistics`;
export const api_dashboard_send_message_access = `/dashboard/send-message-access`;
export const api_dashboard_shipment_by_statistics_status = `/dashboard/shipment-by-statistic-status`;
export const api_dashboard_shipment_by_statusId = `/dashboard/shipment-by-statusId`;
export const api_dashboard_volumetry_by_destination = `/dashboard/volumetry-by-destination`;
export const api_dashboard_planned_and_done = `/dashboard/planned-and-done`;
export const api_shipment_history = `/ShipmentHistory`;
export const api_shipment_send_message = `/ShipmentHistory/sendMessage`;
export const api_milestone_type = `/MilestoneType`;
export const api_order_items = `/OrderItem`;
export const api_shipment_di = `/ShipmentDI`;
export const api_shipment_get_awaiting_arrival_intransit = `/Shipment/GetAwaitingArrivalinTransit`;
export const api_shipment_get_dermuge_finished = `/Shipment/GetDermugerFinished`;
export const api_shipment_get_dermuge_cost = `/Shipment/GetDemurrageCost`;
export const api_shipment_free_time = `/shipment/ShipmentFreeTime`;
export const api_shipment_free_time_container_return = `/shipment/ContainerReturn`;
export const api_customer_proposal_update_details_after_approved = `/customerProposal/update-details-after-approved`;
export const api_shipment_order_items = `/ShipmentOrderItems`;
export const api_shipment_order_items_list_by_shipment = `/ShipmentOrderItems/list-by-shipment`;
export const api_shipment_order_items_update_documents = `/ShipmentOrderItems/update-documents`;
export const api_import_order_items = `/orderItem/import`;
export const api_customer_manufacturer = `/CustomerManufacturer`;
export const api_customer_parameter = `/CustomerParameter`;
export const api_customer_provider = `/CustomerProvider`;
export const api_trix_activity = `/TrixActivity`;
export const api_template_shipment_activity = `/TemplateShipmentActivity`;
export const api_trix_order_item = `/TrixOrderItem`;
export const api_customer_supplier = `/CustomerSupplier`;
export const api_customer_product = `/CustomerProduct`;
export const api_customer_product_import = `/CustomerProduct/import`;
export const api_customer_terminal = `/CustomerTerminal`;
export const api_customer_terminal_import = `/CustomerTerminal/import`;
export const api_shipment_journey_steps = `/ShipmentJourneyStep`;
export const api_shipment_activity = `/ShipmentActivity`;
export const api_shipment_activity_message = `/ShipmentActivityMessage`;
export const api_shipment_activity_from_user = `/ShipmentActivity/from-user`;
export const api_customer_customer = `/CustomerCustomer`;
export const api_customer_proposal = `/CustomerProposal`;
export const api_customer_notification_order_item = `/CustomerNotificationOrderItem`;
export const api_send_proposal = `/CustomerProposal/send`;
export const api_customer_carrier = `/CustomerCarrier`;

export const api_vsantos_process = `/VSantos/process/list`;
export const api_vsantos_get_li = `/VSantos/getli`;
export const api_vsantos_get_empresa = `/VSantos/process/empresa`;
export const api_vsantos_get_imposto = `/VSantos/process/imposto`;
export const api_vsantos_get_carga = `/VSantos/process/carga`;
export const api_vsantos_get_cct = `/VSantos/process/cct`;
export const api_vsantos_get_desembaraco = `/VSantos/process/desembaraco`;
export const api_vsantos_get_mercante = `/VSantos/process/mercante`;
export const api_vsantos_get_invoices = `/VSantos/process/invoices`;
export const api_vsantos_get_observacoes = `/VSantos/process/observacoes`;

export const api_vsantos_get_mantra = `/VSantos/process/mantra`;
export const api_vsantos_get_dashboard = `/VSantos/process/dashboard`;
export const api_vsantos_get_despesas = `/VSantos/process/despesas`;
export const api_vsantos_get_numerarios = `/VSantos/process/numerarios`;

export const api_vsantos_get_arquivos = `/VSantos/process/arquivos`;
export const api_vsantos_get_download = `/VSantos/process/download`;
export const api_vsantos_get_custo_por_item = `/VSantos/process/custoporitem`;

export const api_vsantos_get_custo_por_processo = `/VSantos/process/CustoPorProcesso`;
export const api_vsantos_get_performance_aerea = `/VSantos/process/PerformanceAerea`;
export const api_vsantos_get_performance_maritima = `/VSantos/process/PerformanceMaritima`;
export const api_vsantos_get_performance_rodoviario = `/VSantos/process/PerformanceRodoviario`;

export const api_history_tractian = `/HistoryTractian`;

// UserProfile EndPoints
export const api_update_order_items = `/OrderItem/partial`;
export const api_user_profile = `/user/profile`;
export const api_user_profiles = `/user/profiles`;

export const api_ongoing_processes = `/OngoingProcesses`;
export const api_completed_processes = `/CompletedProcesses`;
export const api_transit_time = `/TransitTime`;
export const api_dashboard_access = `/DashboardAccess`;

export const api_cep_search = `https://viacep.com.br/ws`;
export const api_template_shipment_milestone = `/TemplateShipmentMilestone`;
export const api_template_shipment_milestone_order = `/TemplateShipmentMilestone/order`;
export const api_template_shipment_milestone_status = `/TemplateShipmentMilestone/status`;

export const api_user_update_profile = `/user/profile`;

export const api_get_componentsregistry = `/ComponentsRegistry`;

export const api_get_partner_dash = `/Partner/Dash`;
export const api_get_shipment_leadtime_month = `/shipment/leadtime-month`;

export const api_shipment_invoice = '/ShipmentInvoice'
export const api_shipment_invoice_item = '/ShipmentInvoiceItem'

export const api_shipment_packing_list = '/ShipmentPackingList'
export const api_shipment_packing_list_item = '/ShipmentPackingListItem'

export const api_get_early_payment = `/paymentmanagement/early-payment`;
export const api_get_all_payment_shipment_integration = `/paymentmanagement/payment-shipment-integration`;
export const api_get_early_payment_calculate = `/paymentmanagement/calculate`;
export const api_delete_early_payment = `/paymentmanagement/early-payment-delete`;
export const api_approve_early_payment = `/paymentmanagement/early-payment-approve`;
export const api_post_early_payment = `/paymentmanagement/early-payment`;
export const api_get_load_info_payment = `/paymentmanagement/load-info-topayment`;
export const api_patch_early_payment = `/paymentmanagement/early-payment`;
export const api_put_early_payment = `/paymentmanagement/early-payment`;
export const api_post_early_payment_upload = `/paymentmanagement/upload`;
export const api_get_download_document_payment = `/paymentmanagement/download`;
export const api_put_erp_integration = `/paymentmanagement/generate-erp-integration`;
export const api_payment_management_validate_expense_txt = `/paymentmanagement/validate-expense-txt`;
export const api_payment_management_import_expense_txt = `/paymentmanagement/import-expense-txt`;
export const api_payment_management_validate_di_txt = `/paymentmanagement/validate-di-txt`;
export const api_early_payment = `/paymentmanagement`;

// Finance Dashboard EndPoints
export const api_get_cockpit_dashboard_finance = `/financedashboard/expenses-by-category`;
export const api_get_last_bills_paid = `/financedashboard/last-bills-paid`;
export const api_get_top_payment_providers = `/financedashboard/top-payment-providers`;
export const api_get_expenses_by_month = `/financedashboard/expenses-by-month`;
export const api_get_payment_volumetry_by_status = `/financedashboard/payment-volumetry-by-status`;
export const api_get_representation_by_providers = `/financedashboard/representation-by-providers`;
export const api_get_comparison_operating_costs = `/financedashboard/comparison-operating-costs`;
export const api_get_expense_calendar = `/financedashboard/expense-calendar`;
export const api_get_expected_actual_operating_expenses = `/financedashboard/expected-actual-operating-expenses`;

export const api_get_shipmentDepartureControl = `/shipment/shipment-departure-control`;
export const api_get_performance_agent_dealer = `/shipment/performance-by-agent-dealer`;
export const api_get_container_by_shipment_status = `/shipment/container-by-shipment-status`;

// Tracking Control Tower EndPoints
export const api_tracking_control = `/TrackingControl`;
export const api_booking_tracking = `/BookingTracking`;
export const api_booking_tracking_dashboard = `/BookingTracking/dashboard`;
export const api_booking_tracking_list = `/BookingTracking/list`;
export const api_booking_tracking_reprocess = `/BookingTracking/reprocess`;
export const api_booking_tracking_reprocess_batch = `/BookingTracking/reprocess-batch`;

// Integration Control Dash (Monitoramento - Integrações) EndPoints
export const api_integration_control_dash_dashboard = `/integrationcontroldash/dashboard`;
export const api_integration_control_dash_list = `/integrationcontroldash/list`;

// DUIMP Control Tower EndPoints
export const api_duimp_control_dashboard = `/integrationcontrol/dashboard`;
export const api_duimp_control_list = `/integrationcontrol/list`;
export const api_duimp_control = `/integrationcontrol`;
export const api_integration_control_reprocess = `/integrationcontrol/reprocess`;
export const api_integration_system_list = `/integrationsystem/list`;
export const api_integration_type_list = `/integrationtype/list`;
